import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import { EventResponse } from '~client/model/admin/event-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

//TODO(Dmitry): Create internal models & mappers
export type CreateEventProfileTask = OneArgTask<EventProfileCreateRequest, EventResponse>;

/**
 * Creates a new Event Profile
 * @param request
 */
export const performCreateEventProfile = (
  request: EventProfileCreateRequest,
): Observable<EventResponse> => apiClient.eventAdminController.createEventProfile$(request);

export const createEventProfileTaskFactory = (): CreateEventProfileTask =>
  rxTask<EventProfileCreateRequest, EventResponse>(performCreateEventProfile);



// WEBPACK FOOTER //
// ./interactor/event/perform-create-event-profile.ts